import styled from 'styled-components';

const TagNotificationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export { TagNotificationWrapper, Wrapper };
